(() => {
  const CLASS_NAME = 'ir-card-swipe-dots';
  let scanQueued = false;

  const getSlides = (slideshow) => {
    const slides = slideshow.slides;
    if (slides) return Array.from(slides);
    return Array.from(slideshow.querySelectorAll('slideshow-slide:not([hidden])'));
  };

  const sync = (slideshow) => {
    const dots = slideshow.querySelector(`.${CLASS_NAME}`);
    if (!dots) return;

    const slides = getSlides(slideshow);
    const maxIndex = Math.max(0, slides.length - 1);
    const current = Math.min(maxIndex, Math.max(0, Number(slideshow.current) || 0));

    Array.from(dots.children).forEach((dot, index) => {
      dot.classList.toggle('is-active', index === current);
    });
  };

  const rebuild = (slideshow) => {
    const slides = getSlides(slideshow);
    const container = slideshow.querySelector('slideshow-container') || slideshow;
    let dots = slideshow.querySelector(`.${CLASS_NAME}`);

    if (slides.length <= 1 || slideshow.disabled) {
      dots?.remove();
      return;
    }

    if (!dots || dots.children.length !== slides.length) {
      dots?.remove();
      dots = document.createElement('div');
      dots.className = CLASS_NAME;
      dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = slides.map(() => '<span></span>').join('');
      container.appendChild(dots);
    }

    sync(slideshow);
  };

  const init = (slideshow) => {
    if (slideshow.dataset.irSwipeDotsReady === 'true') {
      rebuild(slideshow);
      return;
    }

    const scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller) return;

    slideshow.dataset.irSwipeDotsReady = 'true';
    let ticking = false;
    let rebuildQueued = false;

    scroller.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            sync(slideshow);
            ticking = false;
          });
        });
      },
      { passive: true }
    );

    const observer = new MutationObserver(() => {
      if (rebuildQueued) return;
      rebuildQueued = true;
      queueMicrotask(() => {
        rebuild(slideshow);
        rebuildQueued = false;
      });
    });

    observer.observe(slideshow, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['hidden', 'initial-slide', 'disabled'],
    });

    rebuild(slideshow);
  };

  const scan = async () => {
    if (!customElements.get('slideshow-component')) {
      await customElements.whenDefined('slideshow-component');
    }

    document.querySelectorAll('.card-gallery slideshow-component').forEach(init);
  };

  const queueScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(() => {
      scan();
      scanQueued = false;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueScan, { once: true });
  } else {
    queueScan();
  }

  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
